class CartSkincarePromotion extends HTMLElement {
  connectedCallback() {
    this.checkExpiry = this.checkExpiry.bind(this);
    document.addEventListener('visibilitychange', this.checkExpiry);
    this.checkExpiry();
  }

  disconnectedCallback() {
    clearTimeout(this.expiryTimer);
    document.removeEventListener('visibilitychange', this.checkExpiry);
  }

  checkExpiry() {
    clearTimeout(this.expiryTimer);
    const endsAt = Number(this.dataset.endsAt) * 1000;
    if (!Number.isFinite(endsAt) || endsAt <= Date.now()) {
      this.remove();
      return;
    }
    this.expiryTimer = setTimeout(this.checkExpiry, Math.min(endsAt - Date.now(), 2147483647));
  }
}

if (!customElements.get('cart-skincare-promotion')) {
  customElements.define('cart-skincare-promotion', CartSkincarePromotion);
}
